import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import { ProductPropType } from "web/types/product";
import Expandable from "web/react/components/expandable/expandable";
import ReadMoreLess from "web/react/components/read-more-less/read-more-less";
import styles from "./product-description-details.css";

function ProductDescriptionDetails({ product, className, productAreaAccordions }) {
    const productDescriptionContent = (
        <>
            <p className={styles.noMarginTop}>{product.long_description}</p>
            {product.more_descriptions &&
                product.more_descriptions.descriptions &&
                product.more_descriptions.descriptions.map((productDescription) => (
                    <React.Fragment key={productDescription.from_retailer_name}>
                        <h4>{productDescription.from_retailer_name}</h4>
                        <p>{productDescription.short_description}</p>
                        <p>{productDescription.description}</p>
                    </React.Fragment>
                ))}
        </>
    );

    return productAreaAccordions ? (
        <div className={className}>
            <Expandable
                renderLabel={() => <h4>{gettext("in_stock_product.details")}</h4>}
                onClick={(isOpen) => {
                    if (!isOpen) {
                        analytics.event("product area", "click", "open-details");
                    }
                }}
            >
                <div>{productDescriptionContent}</div>
            </Expandable>
        </div>
    ) : (
        <div className={classnames(className)}>
            <h4>{gettext("in_stock_product.details")}</h4>
            <ReadMoreLess key={product.product_id}>{productDescriptionContent}</ReadMoreLess>
        </div>
    );
}

ProductDescriptionDetails.propTypes = {
    product: ProductPropType.isRequired,
    className: PropTypes.string,
    productAreaAccordions: PropTypes.bool,
};

ProductDescriptionDetails.defaultProps = {
    productAreaAccordions: false,
};

export default ProductDescriptionDetails;
